import type { HTMLAttributes } from 'react';
import { cn } from '@/lib/utils';
import type { Tone } from './icon-chip';

export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'bg-surface-raised border border-border rounded-(--radius-lg) shadow-sm',
        className,
      )}
      {...props}
    />
  );
}

/* כותרת כרטיס עם גוון — זהות לסוג הכרטיס (למשל בסקירה). הרקע עדין מספיק
   כדי שהטקסט (fg) יישאר ≥12:1; הצבע מגיע בעיקר מ-IconChip שבכותרת. */
const HEADER_TONE: Record<Tone, string> = {
  accent: 'bg-accent-subtle/60 border-accent-border/50',
  success: 'bg-success-subtle/60 border-success-border/50',
  warning: 'bg-warning-subtle/60 border-warning-border/50',
  danger: 'bg-danger-subtle/60 border-danger-border/50',
  info: 'bg-info-subtle/60 border-info-border/50',
  violet: 'bg-violet-subtle/60 border-violet-border/50',
  teal: 'bg-teal-subtle/60 border-teal-border/50',
  orange: 'bg-orange-subtle/60 border-orange-border/50',
  pink: 'bg-pink-subtle/60 border-pink-border/50',
};

export function CardHeader({
  className,
  tone,
  ...props
}: HTMLAttributes<HTMLDivElement> & { tone?: Tone }) {
  return (
    <div
      className={cn(
        'px-5 py-4 border-b border-border',
        tone && ['rounded-t-[calc(var(--radius-lg)-1px)]', HEADER_TONE[tone]],
        className,
      )}
      {...props}
    />
  );
}

export function CardTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h3
      className={cn('text-sm font-semibold text-fg leading-(--leading-tight)', className)}
      {...props}
    />
  );
}

export function CardDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn('text-xs text-fg-muted mt-0.5', className)} {...props} />;
}

export function CardContent({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('p-5', className)} {...props} />;
}

export function CardFooter({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('px-5 py-3 border-t border-border bg-surface-sunken/50 rounded-b-(--radius-lg)', className)}
      {...props}
    />
  );
}
